import { Component, computed, inject, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { EWidget, EWidgetRequestCategory } from 'scw-digital-boards-widgets';
import { IDropdownOption, MatDropdown } from '../../../../../shared/components/mat-dropdown/mat-dropdown.component';

@Component({
  imports: [MatDropdown],
  selector: 'widget-request-category-dropdown',
  templateUrl: './widget-request-category-dropdown.component.html',
})
export class WidgetRequestCategoryDropdownComponent {
  private readonly translate = inject(TranslateService);

  public readonly formControl = input.required<FormControl<IDropdownOption<EWidgetRequestCategory>[]>>();
  public readonly type = input.required<EWidget>();
  public readonly isFormSubmitted = input.required<boolean>();
  public readonly dropdownLabel = input.required<string>();

  public readonly widgetRequestCategoryDropdownOptions = computed(() => {
    const allOptions: IDropdownOption<EWidgetRequestCategory>[] = Object.values(EWidgetRequestCategory).map((name) => ({
      id: name,
      name: this.translate.instant(`page.widgetContent.addEditDialog.widgetRequestCategoryDropdown.options.${name}`),
    }));

    try {
      if (this.type() === EWidget.ratio) {
        return allOptions.filter(({ id }) => id !== EWidgetRequestCategory.formSubmissions);
      }
    } catch (_) {
      return allOptions;
    }

    return allOptions;
  });

  public readonly widgetRequestCategoryDropdownConfiguration = computed(() => {
    const fields = {
      enableSearchFilter: false,
      hasDelayedDefaultValue: true,
      isClientSide: true,
      repositionDropdownList: true,
      singleSelection: true,
    };

    try {
      return {
        ...fields,
        text: this.dropdownLabel(),
      };
    } catch (_) {
      return {
        ...fields,
        text: '',
      };
    }
  });
}
